import { HpAction } from './actionTypes';

export const ACTION_MODAL_TYPE = {
  AGENT_FEATURE_UNAVAILABLE: 'agent-feature-unavailable',
  CUSTOMER_FEATURE_UNAVAILABLE: 'customer-feature-unavailable',
  CUSTOMER_CONTACT_US: 'customer-contact-us'
} as const;

export type ActionModalType = (typeof ACTION_MODAL_TYPE)[keyof typeof ACTION_MODAL_TYPE];

export type OpenActionModalPayload =
  | { modalType: 'agent-feature-unavailable'; alertMessage?: string }
  | { modalType: 'customer-feature-unavailable' }
  | { modalType: 'customer-contact-us' };

export function openActionModal(payload: OpenActionModalPayload): HpAction<OpenActionModalPayload> {
  return {
    type: 'OPEN_ACTION_MODAL',
    payload
  };
}

export function openAgentFeatureNotAvailableModal(alertMessage?: string): HpAction<OpenActionModalPayload> {
  return openActionModal({ modalType: 'agent-feature-unavailable', alertMessage });
}

export function openCustomerFeatureNotAvailableModal(): HpAction<OpenActionModalPayload> {
  return openActionModal({ modalType: 'customer-feature-unavailable' });
}

export function openCustomerContactUsModal(): HpAction<OpenActionModalPayload> {
  return openActionModal({ modalType: 'customer-contact-us' });
}

export function openFeatureNotAvailableModal(
  isAgent: boolean,
  alertMessage?: string
): HpAction<OpenActionModalPayload> {
  return isAgent ? openAgentFeatureNotAvailableModal(alertMessage) : openCustomerFeatureNotAvailableModal();
}

export function closeActionModalAction(): HpAction<void> {
  return {
    type: 'CLOSE_ACTION_MODAL'
  };
}
